// export const APIBaseURL = 'http://localhost:3000'
export const APIBaseURL = 'https://rjback.freshgrad.com'
export const ImageUploadURL = 'https://rjback.freshgrad.com/adminapi/editor-image-upload'
// export const key = 'rzp_test_ontnDNBQoN17AN'
// export const key_secret = 'e7RyAy3TDKS8iJLL8bW9rxnp'
